import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useNotification } from '@oolio-group/hooks';
import NotificationComponent from './Notification';

const styles = StyleSheet.create({
  container: {
    top: 0,
    width: '100%',
    zIndex: 20,
    elevation: 20,
    position: 'absolute',
  },
});

export const NotificationList: React.FC = () => {
  const { notifications, closeNotification } = useNotification();
  return (
    <View style={styles.container}>
      {notifications.length > 0
        ? notifications.map((notification, index) => (
            <NotificationComponent
              key={index}
              {...notification}
              onClose={closeNotification.bind(null, notification.id)}
            />
          ))
        : null}
    </View>
  );
};

NotificationList.displayName = 'NotificationList';
